"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StateReducer = exports.SendAnalytics = exports.MoveToTop = exports.MoveToResults = exports.Methods = exports.GetTestIds = exports.DefaultStyles = exports.CalculatorState = exports.CalculatorDispatch = void 0;
var _CalculatorProvider = require("./CalculatorProvider");
var _ContentContainer = _interopRequireDefault(require("../../components/ContentContainer/ContentContainer"));
var _ImportedContentFragment = _interopRequireDefault(require("../../components/ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _analytics = require("../../utils/analytics");
var _array = require("../../utils/type-checks/array");
var _boolean = require("../../utils/type-checks/boolean");
var _number = require("../../utils/type-checks/number");
var _object = require("../../utils/type-checks/object");
var _scroll = require("../../utils/scroll");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _string = require("../../utils/type-checks/string");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
Promise.resolve().then(() => _interopRequireWildcard(require("../../scss/partials/_calculator-print.scss")));
const merge = require("deepmerge"),
  CalculatorCustomTheme = /*#__PURE__*/(0, _react.createContext)(null),
  CalculatorState = exports.CalculatorState = /*#__PURE__*/(0, _react.createContext)(null),
  CalculatorDispatch = exports.CalculatorDispatch = /*#__PURE__*/(0, _react.createContext)(null),
  CalculatorDefaultState = /*#__PURE__*/(0, _react.createContext)(null),
  DefaultStyles = theme => ({
    ".calculator__header": {
      backgroundColor: "#F4F5F8",
      padding: "7.5rem 2rem 10rem",
      ".ContentContainer__box": {
        textAlign: "center"
      }
    },
    ".calculator__content": {
      backgroundColor: "white",
      borderColor: "rgba(0,0,0,0.15)",
      borderStyle: "solid",
      borderWidth: "0.1rem",
      display: "grid",
      columnGap: "4rem",
      gridTemplateColumns: {
        xs: "100%",
        md: "repeat(2, minmax(0, 1fr))"
      },
      marginTop: "-5rem",
      padding: {
        xs: "3rem 2rem 4rem 4rem",
        md: "7.8rem 2rem 4rem 4rem"
      }
    }
  }),
  GetTestIds = testId => {
    return {
      component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
      header: (0, _string.isStringOfLength)(testId) ? `${testId}__header` : undefined,
      form: (0, _string.isStringOfLength)(testId) ? `${testId}__form` : undefined,
      title: (0, _string.isStringOfLength)(testId) ? `${testId}__title` : undefined
    };
  },
  MoveToTop = target => {
    const top = (0, _string.isStringOfLength)(target) ? document.querySelector(target) : document.querySelector("#calculator__top");
    if (top) {
      (0, _scroll.scrollToElement)(top);
    }
  },
  MoveToResults = target => {
    const results = (0, _string.isStringOfLength)(target) ? document.querySelector(target) : document.querySelector(".calculator__result--isCard");
    if (results) {
      (0, _scroll.scrollToElement)(results);
    }
  },
  SendAnalytics = (quizName, quizEvent) => {
    let result = false;
    if ((0, _string.isStringOfLength)(quizName) && (0, _string.isStringOfLength)(quizEvent)) {
      (0, _analytics.createEventGA4)(`${quizEvent}:${quizName}`);
      result = true;
    }
    return result;
  },
  StateReducer = (state, action) => {
    const workingState = merge({}, state);
    let result = {
      ...workingState
    };
    switch (action.type) {
      case "jumpToPanel":
        result = {
          ...workingState,
          isReset: true,
          panelIndex: (0, _number.isNumber)(action.panelIndex) ? action.panelIndex : 0,
          direction: !(0, _number.isNumber)(action.panelIndex) && 1 || state.panelIndex <= action.panelIndex ? 1 : -1
        };
        break;
      case "navigatePanelBack":
        result = {
          ...workingState,
          panelIndex: workingState.panelIndex - 1,
          direction: -1
        };
        break;
      case "navigatePanelForward":
        result = {
          ...workingState,
          panelIndex: workingState.panelIndex + 1,
          direction: 1
        };
        break;
      case "resetState":
        result = {
          ...workingState,
          formState: action.resetStateObj,
          isReset: true,
          panelIndex: 0,
          direction: 1
        };
        break;
      case "setForm":
        if ((0, _object.isObject)(action.formState)) {
          result = {
            ...workingState,
            formState: action.formState
          };
        }
        break;
      case "setData":
        result = {
          ...workingState
        };
        if ((0, _array.isArrayOfLength)(action.array)) {
          action.array.forEach(obj => {
            if ((0, _string.isStringOfLength)(obj.name)) {
              result.data[obj.name] = obj.value;
            }
          });
        } else if ((0, _object.isObject)(action.data)) {
          result.data = {
            ...action.data
          };
        } else if ((0, _string.isStringOfLength)(action.name)) {
          result.data[action.name] = action.value;
        }
        break;
      case "toggleReset":
        result = {
          ...workingState,
          isReset: !workingState.isReset
        };
        break;
      case "updateForm":
        if ((0, _string.isStringOfLength)(action.name) && ((0, _string.isString)(action.value) || (0, _boolean.isBoolean)(action.value))) {
          result = {
            ...workingState,
            formState: {
              ...workingState.formState,
              [`${action.name}`]: action.value
            }
          };
        }
        break;
      default:
        result = {
          ...workingState
        };
        break;
    }
    return result;
  },
  Methods = exports.Methods = {
    GetTestIds: GetTestIds,
    moveToTop: MoveToTop,
    moveToResults: MoveToResults,
    sendAnalytics: SendAnalytics,
    stateReducer: StateReducer,
    useCustomTheme: () => (0, _react.useContext)(CalculatorCustomTheme),
    useDispatch: () => (0, _react.useContext)(CalculatorDispatch),
    useState: () => (0, _react.useContext)(CalculatorState),
    useDefaultFormState: () => (0, _react.useContext)(CalculatorDefaultState)
  };

/**
 * Form and State Management for Calculator Views
 *
 * @visibleName Calculator Provider
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.StateReducer = StateReducer;
exports.SendAnalytics = SendAnalytics;
exports.MoveToResults = MoveToResults;
exports.MoveToTop = MoveToTop;
exports.GetTestIds = GetTestIds;
exports.DefaultStyles = DefaultStyles;
const CalculatorProvider = props => {
  const {
      children,
      className,
      customData = {},
      customTheme = {},
      defaultFormState,
      defaultIsReset = false,
      footnote,
      formState,
      fragmentId,
      name = "calculator__form",
      novalidate = true,
      panelIndex = 0,
      styles = {},
      testId,
      title,
      titleTag = "h2"
    } = props,
    [state, dispatch] = (0, _react.useReducer)(_CalculatorProvider.Methods.stateReducer, {
      data: customData,
      isReset: defaultIsReset,
      formState: {
        ...formState
      },
      panelIndex: panelIndex,
      direction: 1
    }),
    compositeTheme = merge((0, _material.useTheme)(), customTheme),
    compositeStyles = merge(DefaultStyles(compositeTheme), styles),
    customClasses = (0, _classnames.default)({
      "calculator": true,
      [`${className}`]: className
    }),
    testIdObject = (0, _react.useMemo)(() => _CalculatorProvider.Methods.GetTestIds(testId), [testId]);
  return /*#__PURE__*/_react.default.createElement(CalculatorCustomTheme.Provider, {
    value: compositeTheme
  }, /*#__PURE__*/_react.default.createElement(CalculatorDispatch.Provider, {
    value: dispatch
  }, /*#__PURE__*/_react.default.createElement(CalculatorState.Provider, {
    value: state
  }, /*#__PURE__*/_react.default.createElement(CalculatorDefaultState.Provider, {
    value: defaultFormState
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: customClasses,
    "data-testid": testIdObject.component,
    sx: compositeStyles
  }, /*#__PURE__*/_react.default.createElement(_ContentContainer.default, {
    className: "calculator__header",
    customTheme: compositeTheme,
    testId: testIdObject.header
  }, (0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "heading--isInteriorPageSubHeading calculator__title",
    component: titleTag,
    "data-testid": testIdObject.title
  }, title), title && !(0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "heading--isInteriorPageSubHeading calculator__title",
    component: "div",
    "data-testid": testIdObject.title
  }, title), (0, _string.isStringOfLength)(fragmentId) && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  })), /*#__PURE__*/_react.default.createElement(_ContentContainer.default, {
    className: "calculator__content-container",
    customTheme: compositeTheme
  }, novalidate ? /*#__PURE__*/_react.default.createElement("form", {
    className: "calculator__content",
    "data-testid": testIdObject.form,
    id: "calculator__top",
    name: name,
    noValidate: true
  }, children) : /*#__PURE__*/_react.default.createElement("form", {
    className: "calculator__content",
    "data-testid": testIdObject.form,
    id: "calculator__top",
    name: name
  }, children), (0, _string.isStringOfLength)(footnote) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__footnote",
    component: "div"
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: footnote
  })), footnote && !(0, _string.isStringOfLength)(footnote) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__footnote",
    component: "div"
  }, footnote)))))));
};

// Define propTypes;
CalculatorProvider.propTypes = {
  /** Calculator child contents */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Custom Name/Value Hash Data Store (Default Value: {}) */
  customData: _propTypes.default.object,
  /** Custom Theme Object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  defaultIsReset: _propTypes.default.bool,
  /** Optional footnote below calculator */
  footnote: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Initial object of name/values for form */
  formState: _propTypes.default.object.isRequired,
  /** Fragment Id for calculator content */
  fragmentId: _propTypes.default.string,
  /** String to be output (Default Value: "calculator__form") */
  name: _propTypes.default.string,
  /** Boolean to turn on/off constraint validation (Default Value: true) */
  novalidate: _propTypes.default.bool,
  /** Current Panel View (Default Value: 0) */
  panelIndex: _propTypes.default.number,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Title of Calculator */
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Tag for Title Component (Default Value "h2") */
  titleTag: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = CalculatorProvider;